import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import { parseJSONDate } from "src/components/js/statics1";
import { GridContext } from "src/context/GridContext/GridContext";
import { Typography } from "@mui/material";
import MyDivider from "src/components/layout/MyDivider";
import { vehicle_fetch } from "src/components/vehicle/VehicleFunctions";
import { useUserData } from "src/context/userContext";
import { addMinutes } from "date-fns";
import GridKeikkaEditor_Teksti_Tilaus from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Tilaus";
import GridKeikkaEditor_Teksti_Toimitus from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Toimitus";
import GridKeikkaEditor_Teksti_Asiakas from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Asiakas";
import GridKeikkaEditor_Teksti_Tyomaa from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Tyomaa";
import GridKeikkaEditor_Teksti_Pumppaus from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Pumppaus";
import GridKeikkaEditor_Teksti_Tehdas from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Tehdas";
import GridKeikkaEditor_Teksti_Betoni from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Betoni";
import GridKeikkaEditor_Teksti_Lisatiedot from "./GridKeikkaEditor_Teksti/GridKeikkaEditor_Teksti_Lisatiedot";

export default function GridKeikkaEditor_Teksti({ keikka = null, onClose = () => {} }) {
  const { token } = useUserData();
  const { gridKeikka, isLoading, setGridKeikkaEditorIsOpen } = useContext(GridContext) || {};

  const [keikkaState, setKeikkaState] = useState(keikka || gridKeikka);
  const [vehicle, setVehicle] = useState(null);

  useEffect(() => {
    let k = keikka || gridKeikka;
    if (!k.timeStart) k.timeStart = parseJSONDate(k.pumppuAika);
    if (!k.timeEnd) k.timeEnd = addMinutes(k.timeStart, k.pumppuKesto);
    setKeikkaState(keikka || gridKeikka);
  }, []);

  useEffect(() => {
    const asynk = async () => {
      if (keikkaState?.vehicleId > 0) {
        const v = await vehicle_fetch(keikkaState.vehicleId, token);
        setVehicle(v);
      }
    };
    asynk();
  }, [keikkaState.vehicleId]);

  return (
    <div
      style={{
        minHeight: "300px",
        display: "flex",
        flexDirection: "column",
      }}>
      <div
        style={{
          minHeight: "150px",
          padding: "10px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          gap: 6,
        }}>
        {keikkaState?.keikkaOtsikko?.length > 0 && (
          <div className="center" style={{ flexDirection: "column" }}>
            <Typography variant="h6" color="primary">
              {keikkaState?.keikkaOtsikko}
            </Typography>
            <MyDivider />
          </div>
        )}
        <GridKeikkaEditor_Teksti_Tilaus subText={subText} keikkaState={keikkaState} />
        <GridKeikkaEditor_Teksti_Toimitus subText={subText} keikkaState={keikkaState} />
        <GridKeikkaEditor_Teksti_Asiakas subText={subText} keikkaState={keikkaState} />
        <GridKeikkaEditor_Teksti_Tyomaa subText={subText} keikkaState={keikkaState} />
        <GridKeikkaEditor_Teksti_Pumppaus
          subText={subText}
          keikkaState={keikkaState}
          vehicle={vehicle}
        />
        <GridKeikkaEditor_Teksti_Tehdas subText={subText} keikkaState={keikkaState} />
        <GridKeikkaEditor_Teksti_Betoni subText={subText} keikkaState={keikkaState} />
        <GridKeikkaEditor_Teksti_Lisatiedot subText={subText} keikkaState={keikkaState} />
      </div>
      <div style={{ width: "100%", alignSelf: "flex-end" }}>
        <StepButtons
          size="small"
          onCloseKlik={() => {
            setGridKeikkaEditorIsOpen && setGridKeikkaEditorIsOpen(false);
            onClose && onClose();
          }}
          isLoading={isLoading}
          enableButtonAfterKlik
        />
      </div>
    </div>
  );

  function subText(txt) {
    if (!txt) return null;
    txt = (txt + "").trim();
    if (txt.length === 0 || txt === "null") return null;
    return <>{txt && <div>{txt}</div>}</>;
  }
}

GridKeikkaEditor_Teksti.propTypes = {
  keikka: PropTypes.object,
  onClose: PropTypes.func,
};
